import React from "react";

import { StyledSVG } from "../StyledIcon";

export const CommunityCallIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <circle
        cx="14"
        cy="15"
        r="6.25"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="29"
        cy="17"
        r="4.25"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4854 31.3431L21.2212 31.1975L20.4854 31.3431ZM21.2643 39.1455C21.3446 39.5519 21.7392 39.8161 22.1455 39.7357C22.5519 39.6554 22.8161 39.2608 22.7357 38.8545L21.2643 39.1455ZM4.28098 31.7867C4.16316 32.1838 4.38956 32.6012 4.78666 32.719C5.18377 32.8368 5.6012 32.6104 5.71902 32.2133L4.28098 31.7867ZM13.982 25.25H11.3558V26.75H13.982V25.25ZM19.7497 31.4886L21.2643 39.1455L22.7357 38.8545L21.2212 31.1975L19.7497 31.4886ZM11.3558 25.25C9.56417 25.25 8.01012 26.1509 6.81954 27.3799C5.62862 28.6093 4.74624 30.2186 4.28098 31.7867L5.71902 32.2133C6.12268 30.8529 6.89083 29.4621 7.8969 28.4236C8.9033 27.3848 10.0927 26.75 11.3558 26.75V25.25ZM13.982 26.75C16.7893 26.75 19.205 28.7347 19.7497 31.4886L21.2212 31.1975C20.5375 27.741 17.5055 25.25 13.982 25.25V26.75Z"
        fill={iconColor}
      />
      <path
        d="M22.6786 30.164L21.9549 29.9673L22.6786 30.164ZM20.7763 34.3033L20.5796 35.027L22.0271 35.4205L22.2238 34.6967L20.7763 34.3033ZM35.0897 27.0753L34.5567 27.6029L35.0897 27.0753ZM35.9671 29.0276C36.2585 29.322 36.7334 29.3244 37.0277 29.033C37.3221 28.7416 37.3245 28.2667 37.0331 27.9724L35.9671 29.0276ZM30.115 24.25H29.4335V25.75H30.115V24.25ZM21.9549 29.9673L20.7763 34.3033L22.2238 34.6967L23.4024 30.3607L21.9549 29.9673ZM34.5567 27.6029L35.9671 29.0276L37.0331 27.9724L35.6227 26.5476L34.5567 27.6029ZM29.4335 24.25C25.9362 24.25 22.8722 26.5924 21.9549 29.9673L23.4024 30.3607C24.1421 27.639 26.6131 25.75 29.4335 25.75V24.25ZM30.115 25.75C31.7836 25.75 33.3828 26.4172 34.5567 27.6029L35.6227 26.5476C34.1671 25.0773 32.184 24.25 30.115 24.25V25.75Z"
        fill={iconColor}
      />
      <circle
        cx="20"
        cy="20"
        r="19.25"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
